/**
 * Labstep
 *
 * @module components/ProtocolCondition/SmartTable/Modal/Content
 * @desc Protocol Condition Modal Content
 */

import { Flex } from 'labstep-web/core/Flex';
import { GridSmartTable as GridSmartTableProtocolCondition } from 'labstep-web/grid/SmartTableProtocolCondition';
import { EntityView } from 'labstep-web/models/entity-view.model';
import { Experiment } from 'labstep-web/models/experiment.model';
import type React from 'react';
import type { ProtocolConditionSmartTableModalContentProps } from './types';

export const ProtocolConditionSmartTableModalContent: React.FC<
  ProtocolConditionSmartTableModalContentProps
> = ({
  experimentOrProtocol,
  entityView,
  group,
  entities,
  readNextPage,
  status,
}) => {
  return (
    <Flex grow data-cy="components/ProtocolCondition/Modal/Content">
      <GridSmartTableProtocolCondition
        experimentOrProtocol={experimentOrProtocol}
        entityName={EntityView.entityName}
        group={group}
        entities={entities.filter((entity) => !entity.deleted_at)}
        loadMore={readNextPage}
        status={status}
        entityView={entityView}
        fullscreen={true}
        withEmptyState={experimentOrProtocol instanceof Experiment}
      />
    </Flex>
  );
};
